const files = import.meta.glob('./*.js', { eager: true });
const config = {};

for (const file in files) {
	let module = file.split('.')[1].split('/')[1];
	config[module] = files[file][module];
}

export default config;